'use strict';

require('./CompanyLogoService.js');

function CompanyLogoDirective(CompanyLogoService) {
  return {
    restrict: 'E',
    scope: {
      companyId: '&companyId'
    },
    link: function(scope, elem) {
      CompanyLogoService.get({companyId: scope.companyId()}).$promise.then(function(logo) {
        var $el = $('<img>');

        $el.attr('src', logo.data);

        elem.append($el);
      });
    }
  };
}

angular.module('dokiv')
  .directive('companyLogo', ['CompanyLogoService', CompanyLogoDirective]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyLogoDirective.js
// module id = 311
// module chunks = 0